import React from 'react'
import {TableCell, TableRow, TableSortLabel, Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Tr from 'translations/Translations';

function SortIcon(props) {
    return (
        <Tooltip title={Tr('sort')} placement='top'>
            <ArrowDownwardIcon {...props} />
        </Tooltip>
    )
}

function STableRow(
    {
        items = [],
        className,
        cellClassName,
        cellClassNames = []
    }) {

    if (items.length <= 0) return '';

    return (
        <TableRow className={className}>
            {items.map((item, i) => {
                let ccn;
                if (cellClassNames.length > i) {
                    ccn = cellClassNames[i];
                }

                if (item === null) item = '';
                let obj = item;
                if ((typeof item !== 'object') || (typeof item === 'object' && item.value === undefined)) {
                    obj = {value: item}
                }

                const cellBody = () => {
                    if (obj.sort) {
                        return (
                            <TableSortLabel
                                active={obj.sort.active}
                                direction={obj.sort.direction}
                                onClick={obj.sort.onClick}
                                IconComponent={SortIcon}
                            >
                                {obj.value}
                            </TableSortLabel>
                        )
                    }
                    return obj.value;
                }

                return <TableCell
                    key={i}
                    colSpan={obj.colSpan}
                    className={clsx(
                        cellClassName,
                        ccn,
                        obj.className,
                    )}
                >
                    {cellBody()}
                </TableCell>
            })}
        </TableRow>
    )
}

STableRow.propTypes = {
    classes: PropTypes.any,
    items: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.shape({
            value: PropTypes.any,
            className: PropTypes.string,
        }),
        PropTypes.any,
    ]))
}


export default STableRow;